(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function ensureNotificationEl() {
    var el = qs('#cart-notification');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'cart-notification';
    el.className = 'cart-notification';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
    return el;
  }

  function hideNotification(el) {
    el.classList.remove('is-visible');
  }

  function showNotification(item, cartCount) {
    var el = ensureNotificationEl();
    var imgUrl = item.image || (item.featured_image && item.featured_image.url) || '';

    el.innerHTML =
      '<button type="button" class="cart-notification__close" aria-label="Close">&times;</button>' +
      '<div class="cart-notification__header">' +
        '<span class="cart-notification__check">&#10003;</span>' +
        '<span>Item added to your cart</span>' +
      '</div>' +
      '<div class="cart-notification__product">' +
        (imgUrl ? '<img src="' + imgUrl + '" alt="">' : '') +
        '<div class="cart-notification__product-title">' + item.product_title + '</div>' +
      '</div>' +
      '<div class="cart-notification__actions">' +
        '<a class="cart-notification__btn cart-notification__btn--checkout" href="/cart">Checkout (' + cartCount + ')</a>' +
        '<button type="button" class="cart-notification__btn cart-notification__btn--continue" data-close>Continue shopping</button>' +
      '</div>';

    el.classList.add('is-visible');

    var closeBtn = qs('.cart-notification__close', el);
    if (closeBtn) closeBtn.addEventListener('click', function () { hideNotification(el); });

    var contBtn = qs('[data-close]', el);
    if (contBtn) contBtn.addEventListener('click', function () { hideNotification(el); });

    clearTimeout(el._hideTimeout);
    el._hideTimeout = setTimeout(function () { hideNotification(el); }, 6000);
  }

  function updateCartCount(count) {
    qsa('.cart_count').forEach(function (node) {
      node.textContent = '(' + count + ')';
    });
  }

  function handleAddToCart(button) {
    if (button.classList.contains('is-loading')) return;

    var wrapper = button.closest('.quick-add-cart');
    if (!wrapper) return;

    var variantId = wrapper.getAttribute('data-variant-id');
    var qtyInput = qs('.quick-add-cart__qty-input', wrapper);
    var quantity = parseInt(qtyInput && qtyInput.value, 10) || 1;

    if (!variantId) return;

    button.classList.add('is-loading');
    button.classList.remove('is-error');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) { throw new Error('add_failed'); }
        return res.json();
      })
      .then(function (item) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            showNotification(item, cart.item_count);
          });
      })
      .catch(function () {
        button.classList.add('is-error');
        setTimeout(function () { button.classList.remove('is-error'); }, 2000);
      })
      .finally(function () {
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.quick-add-cart__qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      var wrapper = qtyBtn.closest('.quick-add-cart');
      var input = qs('.quick-add-cart__qty-input', wrapper);
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      if (qtyBtn.getAttribute('data-action') === 'increase') {
        val += 1;
      } else {
        val = Math.max(1, val - 1);
      }
      input.value = val;
      return;
    }

    var submitBtn = e.target.closest('.quick-add-cart__submit');
    if (submitBtn) {
      e.preventDefault();
      handleAddToCart(submitBtn);
    }
  });
})();
